module.exports = __webpack_public_path__ + "static/media/form-arrow.5acabe35.svg";